<template>
  <div class="sliders-wrap">
    <div v-for="(_, i) in rowCount" :key="i" class="slider-row">

      <!-- Encabezado: ícono + nombre amigable + valor -->
      <div class="slider-header">
        <div class="slider-label-wrap">
          <v-icon
            v-if="icons && icons[i]"
            small
            :color="sliderColors[i]"
            class="mr-1"
          >{{ icons[i] }}</v-icon>
          <span
            v-if="labels && labels[i]"
            class="slider-label"
            :style="{ color: sliderColors[i] }"
          >{{ labels[i] }}</span>
        </div>
        <span class="slider-value" :style="{ color: sliderColors[i] }">{{ localValues[i] }}</span>
      </div>

      <!-- Descripción del cuadrante -->
      <p v-if="descriptions && descriptions[i]" class="slider-desc">
        {{ descriptions[i] }}
      </p>

      <v-slider
        v-model="localValues[i]"
        :color="sliderColors[i]"
        track-color="grey lighten-3"
        :min="0"
        :max="100"
        thumb-label
        dense
        hide-details
        :disabled="locked"
        @change="onSliderChange(i)"
      ></v-slider>
    </div>

    <!-- Total acumulado -->
    <div class="total-row" :class="totalClass">
      <v-icon small :color="totalIconColor" class="mr-1">{{ totalIcon }}</v-icon>
      <span>
        {{ $t('culture_sliders.total') }}:
        <strong>{{ total }} / 100</strong>
      </span>
      <span v-if="total === 100" class="ml-2 limit-msg">
        {{ $t('culture_sliders.limit_reached') }}
      </span>
      <span v-else-if="total < 100" class="ml-2 limit-msg">
        {{ $t('culture_sliders.remaining', { n: 100 - total }) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoBalanceSliders',
  props: {
    labels:       { type: Array, default: null },
    value:        { type: Array, default: () => [0, 0, 0, 0] },
    descriptions: { type: Array, default: null },
    icons:        { type: Array, default: null },
    locked:       { type: Boolean, default: false },
  },
  data() {
    return {
      localValues: [...(this.value || [0, 0, 0, 0])],
      sliderColors: ['#2563eb', '#c2853e', '#276749', '#6b7280'],
    };
  },
  computed: {
    rowCount() {
      const len = (this.labels || this.descriptions || this.localValues || []).length;
      return new Array(len);
    },
    total() {
      return this.localValues.reduce((a, b) => a + b, 0);
    },
    totalClass() {
      if (this.total === 100) return 'total-ok';
      if (this.total > 0)    return 'total-partial';
      return 'total-empty';
    },
    totalIcon() {
      if (this.total === 100) return 'mdi-check-circle';
      const slices = Math.max(1, Math.min(8, Math.ceil(this.total / 100 * 8)));
      return 'mdi-circle-slice-' + slices;
    },
    totalIconColor() {
      return this.total === 100 ? 'success' : 'grey';
    },
  },
  watch: {
    value(newVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(this.localValues)) {
        this.localValues = [...newVal];
      }
    }
  },
  methods: {
    onSliderChange(i) {
      const othersSum = this.localValues.reduce((a, v, idx) => idx !== i ? a + v : a, 0);
      const maxAllowed = 100 - othersSum;
      if (this.localValues[i] > maxAllowed) {
        this.$set(this.localValues, i, maxAllowed);
      }
      this.$emit('input', [...this.localValues]);
      this.$emit('change', [...this.localValues]);
    }
  }
}
</script>

<style scoped>
.sliders-wrap { padding: 4px 0; }

.slider-row { margin-bottom: 16px; }

.slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
}
.slider-label-wrap {
  display: flex;
  align-items: center;
}
.slider-label {
  font-size: 0.88rem;
  font-weight: 700;
}
.slider-value {
  font-size: 0.88rem;
  font-weight: 700;
  min-width: 32px;
  text-align: right;
}
.slider-desc {
  font-size: 0.75rem;
  color: #6b7280;
  margin: 0 0 4px 0;
  line-height: 1.35;
  padding-left: 20px;
}

.total-row {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  margin-top: 8px;
  flex-wrap: wrap;
  gap: 4px;
}
.total-ok      { background: #f0fdf4; color: #166534; }
.total-partial { background: #f0f9ff; color: #1e40af; }
.total-empty   { background: #f9fafb; color: #6b7280; }

.limit-msg {
  font-size: 0.78rem;
  opacity: 0.85;
}
</style>
